// extracted by mini-css-extract-plugin
module.exports = {"Promotion":"Promotion_Promotion__luqxM","MainGift":"Promotion_MainGift__jyVIx"};